module.exports = __webpack_public_path__ + "static/media/eye-open.a1e0b7c8.svg";